<script setup>
import { ref, reactive, watch } from 'vue';
import axios from 'axios';

const props = defineProps({
  modelValue: Boolean,
  productVariant: Object,
  productName: Object,
  model: Object,
});

const emit = defineEmits(['update:modelValue']);
const formData = reactive({
  name: '',
  email: '',
  number_phone: '',
  address: '',
  postal_code: '',
  product_name: '',
  product_reference: '',
  product_label: '',
});
watch(() => props.modelValue, (isOpen) => {
  if (isOpen) {
    formData.product_name = props.productVariant?.name || '';
    formData.product_reference = props.productVariant?.reference || '';
    formData.product_label = props.productName?.label_list || '';
  }
});

const isSubmitting = ref(false);
const message = ref({type: '', text: ''});

const trans = (key) => {
  return _.get(window.translations, key, key);
};

const close = () => {
  emit('update:modelValue', false);
  setTimeout(() => { isSubmitted.value = false; }, 300);
};
const isSubmitted = ref(false);
const submitForm = async () => {
  isSubmitting.value = true;
  message.value = {type: '', text: ''};

  try {
    await axios.post('/product-form', formData);
    isSubmitted.value = true;
    resetForm();
    setTimeout(() => {
      if (isSubmitted.value) close();
    }, 5000);

  } catch (error) {
    message.value = {
      type: 'error',
      text: 'Ocorreu um erro ao enviar. Por favor, tente novamente.'
    };
  } finally {
    isSubmitting.value = false;
  }
};

const resetForm = () => {
  formData.name = '';
  formData.email = '';
  formData.number_phone = '';
  formData.address = '';
  formData.postal_code = '';
};

</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="modelValue" class="modal-overlay" @click.self="close">
        <div class="modal-content">
          <div class="content-know-more">
            <button class="close-btn" @click="close">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                <path d="M0.30545 1.7803C0.20861 1.68346 0.131793 1.56849 0.079384 1.44196C0.0269748 1.31544
                1.02037e-09 1.17982 0 1.04287C-1.02037e-09 0.905921 0.0269748 0.77031 0.079384 0.643783C0.131793
                0.517255 0.20861 0.40229 0.30545 0.30545C0.40229 0.20861 0.517255 0.131793 0.643783 0.079384C0.77031
                0.0269748 0.905921 -1.02037e-09 1.04287 0C1.17982 1.02037e-09 1.31544 0.0269748 1.44196
                0.079384C1.56849 0.131793 1.68346 0.20861 1.7803 0.30545L12.5 11.0272L23.2197 0.30545C23.3165
                0.20861 23.4315 0.131793 23.558 0.079384C23.6846 0.0269748 23.8202 0 23.9571 0C24.0941 0 24.2297
                0.0269748 24.3562 0.079384C24.4827 0.131793 24.5977 0.20861 24.6946 0.30545C24.7914 0.40229 24.8682
                0.517255 24.9206 0.643783C24.973 0.77031 25 0.905921 25 1.04287C25 1.17982 24.973 1.31544 24.9206
                1.44196C24.8682 1.56849 24.7914 1.68346 24.6946 1.7803L13.9728 12.5L24.6946 23.2197C24.7914 23.3165
                24.8682 23.4315 24.9206 23.558C24.973 23.6846 25 23.8202 25 23.9571C25 24.0941 24.973 24.2297 24.9206
                24.3562C24.8682 24.4827 24.7914 24.5977 24.6946 24.6946C24.5977 24.7914 24.4827 24.8682 24.3562
                24.9206C24.2297 24.973 24.0941 25 23.9571 25C23.8202 25 23.6846 24.973 23.558 24.9206C23.4315 24.8682
                23.3165 24.7914 23.2197 24.6946L12.5 13.9728L1.7803 24.6946C1.68346 24.7914 1.56849 24.8682 1.44196
                24.9206C1.31544 24.973 1.17982 25 1.04287 25C0.905921 25 0.77031 24.973 0.643783 24.9206C0.517255
                24.8682 0.40229 24.7914 0.30545 24.6946C0.20861 24.5977 0.131793 24.4827 0.079384 24.3562C0.0269748
                24.2297 0 24.0941 0 23.9571C0 23.8202 0.0269748 23.6846 0.079384 23.558C0.131793 23.4315 0.20861
                23.3165 0.30545 23.2197L11.0272 12.5L0.30545 1.7803Z" fill="black"/>
              </svg>
            </button>
            <div class="icon-site">
              <svg xmlns="http://www.w3.org/2000/svg" width="130" height="56" viewBox="0 0 130 56" fill="none">
                <path d="M85.1932 20.8718L77.9803 37.4868L79.7415 41.6319C80.5484 41.1992 81.1658 40.5154 81.6078
              39.5105L89.7258 20.8718H85.1932Z" fill="black"/>
                <path d="M76.3596 38.2196C76.079 38.1288 75.8755 37.9544 75.7632 37.6543L68.7608 20.8718H64.3054L72.0235
              39.5105C72.8163 41.4505 74.374 42.239 76.8016 42.239C77.2437 42.239 77.6576 42.2111 78.0435
              42.1553L76.3666 38.2056L76.3596 38.2196Z" fill="black"/>
                <path d="M95.0583 20.8718V15.9243H99.3173V20.8718H105.127V24.9122H99.3173V34.8072C99.3173 37.1449
              100.152 37.9335 102.138 37.9335H105.043V41.7715H101.261C96.9247 41.7715 95.0513 40.0269 95.0513
              34.57V24.9122H92.1886V20.8718H95.0513H95.0583Z" fill="black"/>
                <path d="M53.5983 20.8718H49.185C43.5719 20.8718 40.0707 24.2771 40.0707 31.3181C40.0707 38.3591
              43.5719 41.7645 49.185 41.7645H53.5983C59.1693 41.7645 62.7126 38.3591 62.7126 31.3181C62.7126 24.2771
              59.1693 20.8718 53.5983 20.8718ZM53.1984 37.6962H49.5779C45.9153 37.6962 44.3226 35.833 44.3226
              31.3251C44.3226 26.8172 45.9153 24.9121 49.5779 24.9121H53.1984C56.8188 24.9121 58.4537 26.8102 58.4537
              31.3251C58.4537 35.84 56.8259 37.6962 53.1984 37.6962Z" fill="black"/>
                <path d="M24.5504 20.8718C31.6721 20.8718 35.1733 24.2353 35.1733 30.0132V41.7645H30.9143V30.0132C30.9143
              26.7265 29.0058 24.9121 24.5855 24.9121H19.653V41.7715H15.394V24.9121H4.73608C4.37824 24.9121 4.21686
              25.1075 4.21686 25.5053V41.6319H0V24.1166C0 21.6603 0.834952 20.8718 2.94689 20.8718H24.5574H24.5504Z"
                      fill="black"/>
                <path d="M81.7131 15.4776C86.7859 11.4233 93.0586 9.02281 99.8364 9.02281C106.614 9.02281 112.88 11.4233
              117.96 15.4776H129.993C122.857 6.03614 112.003 0 99.8364 0C87.67 0 76.8156 6.03614 69.6799
              15.4776H81.7131Z" fill="#EE7623"/>
                <path d="M122.093 37.6962L123.826 41.7715H128.962V37.6962H122.093Z" fill="#A7CB47"/>
                <mask id="mask0_78_315" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="122" y="37" width="7"
                      height="5">
                  <path d="M122.093 37.6962L123.826 41.7715H128.962V37.6962H122.093Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_78_315)">
                  <path d="M123.812 34.7281L120.317 40.7472L127.244 44.7248L130.739 38.7056L123.812 34.7281Z"
                        fill="#A7CB47"/>
                </g>
                <path d="M112.887 27.8011C112.887 26.1752 113.799 24.9121 116.107 24.9121H122.871C124.941 24.9121
              125.853 25.9379 125.853 27.522C125.853 29.106 125.018 30.0132 122.752
              30.0132H112.887V27.7941V27.8011ZM116.107 20.8718C110.852 20.8718 108.789 23.8026 108.789
              27.7592V34.884C108.789 38.8406 110.859 41.7715 116.107 41.7715H121.889L120.156 37.6962H116.107C113.799
              37.6962 112.887 36.468 112.887 34.8072V33.2999H122.871C128.042 33.2999 129.993 31.1227 129.993
              27.2847C129.993 23.2513 127.881 20.8718 122.913 20.8718H116.107Z" fill="#A7CB47"/>
                <mask id="mask1_78_315" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="108" y="20" width="22"
                      height="22">
                  <path d="M112.887 27.8011C112.887 26.1752 113.799 24.9121 116.107 24.9121H122.871C124.941 24.9121
              125.853 25.9379 125.853 27.522C125.853 29.106 125.018 30.0132 122.752
              30.0132H112.887V27.7941V27.8011ZM116.107 20.8718C110.852 20.8718 108.789 23.8026 108.789
              27.7592V34.884C108.789 38.8406 110.859 41.7715 116.107 41.7715H121.889L120.156 37.6962H116.107C113.799
              37.6962 112.887 36.468 112.887 34.8072V33.2999H122.871C128.042 33.2999 129.993 31.1227 129.993
              27.2847C129.993 23.2513 127.881 20.8718 122.913 20.8718H116.107Z" fill="white"/>
                </mask>
                <g mask="url(#mask1_78_315)">
                  <path d="M114.089 11.7452L99.6912 36.5469L124.695 50.9045L139.093 26.1028L114.089 11.7452Z"
                        fill="#A7CB47"/>
                </g>
                <path d="M126.625 47.6122C126.829 47.5704 127.081 47.5424 127.376 47.5145C127.671 47.4866 127.923
              47.4866 128.155 47.4866C128.449 47.4866 128.744 47.5006 129.032 47.5145C129.34 47.5355 129.579 47.5634
              129.761 47.6122L127.657 51.4153L129.993 55.7837C129.79 55.8256 129.537 55.8535 129.228 55.8814C128.919
              55.9093 128.66 55.9093 128.428 55.9093C128.134 55.9093 127.839 55.9023 127.551 55.8814C127.264 55.8604
              127.046 55.8325 126.878 55.7837L124.625 51.527L126.618 47.6122H126.625ZM121.496 47.6122C121.749 47.5634
              121.987 47.5215 122.219 47.5006C122.471 47.4796 122.703 47.4727 122.927 47.4727C123.152 47.4727 123.377
              47.4866 123.622 47.5006C123.875 47.5215 124.113 47.5564 124.345 47.6122V55.7837C124.05 55.8325 123.79
              55.8604 123.545 55.8814C123.313 55.9023 123.096 55.9093 122.92 55.9093C122.731 55.9093 122.521 55.9023
              122.275 55.8814C122.043 55.8744 121.77 55.8395 121.482 55.7837V47.6122H121.496ZM116.192 54.0182C116.297
              54.0182 116.444 54.0112 116.634 53.9903C116.823 53.9694 116.971 53.9484 117.062
              53.9275V52.1829H116.093C115.701 52.1829 115.371 52.2597 115.097 52.4202C114.823 52.5807 114.697 52.797
              114.697 53.0831C114.697 53.2925 114.746 53.4599 114.852 53.5925C114.957 53.7112 115.076 53.7949 115.223
              53.8647C115.385 53.9275 115.546 53.9763 115.715 53.9973C115.883 54.0042 116.051 54.0182 116.199
              54.0182M112.199 53.132C112.199 52.6156 112.319 52.1829 112.55 51.848C112.782 51.513 113.09 51.2409
              113.469 51.0385C113.848 50.8361 114.255 50.7036 114.711 50.6198C115.167 50.5291 115.602 50.4942
              116.03 50.4942H117.062C117.055 50.3058 116.999 50.1453 116.893 50.0197C116.788 49.8871 116.662
              49.8034 116.507 49.7336C116.346 49.6638 116.178 49.608 115.981 49.587C115.792 49.5591 115.595 49.5452
              115.385 49.5452C115.111 49.5452 114.795 49.5731 114.438 49.6429C114.08 49.6917 113.708 49.7824 113.315
              49.915C113.21 49.7336 113.126 49.5731 113.041 49.4196C112.978 49.273 112.915 49.1195 112.873
              48.973C112.838 48.8125 112.817 48.6589 112.782 48.4984C112.768 48.331 112.768 48.1426 112.768
              47.9332C113.308 47.7657 113.848 47.6332 114.381 47.5564C114.922 47.4657 115.406 47.4308 115.841
              47.4308C116.43 47.4308 116.956 47.4936 117.434 47.6332C117.911 47.7588 118.304 47.9611 118.633
              48.2403C118.97 48.5194 119.237 48.8683 119.412 49.3079C119.595 49.7336 119.686 50.243 119.686
              50.8292V55.4766C119.251 55.5953 118.739 55.7069 118.121 55.8256C117.511 55.9442 116.865 56
              116.192 56C115.602 56 115.062 55.9512 114.564 55.8395C114.08 55.7418 113.666 55.5813 113.308
              55.365C112.957 55.1417 112.683 54.8486 112.48 54.4927C112.291 54.1089 112.192 53.6553 112.192
              53.132M99.7944 47.6401C99.2401 47.7588 98.77 47.8774 98.37 48.003V55.7976C98.6647 55.8465
              98.9243 55.8884 99.1699 55.8953C99.4014 55.9163 99.6189 55.9232 99.8154 55.9232C99.9978 55.9232 100.201
              55.9163 100.44 55.8953C100.671 55.8884 100.945 55.8535 101.24 55.7976V49.8662C101.275 49.8452
              101.359 49.8243 101.499 49.8034C101.647 49.7824 101.787 49.7755 101.913 49.7755C102.376 49.7755
              102.706 49.9011 102.896 50.1383C103.085 50.3756 103.183 50.7873 103.183 51.3386V55.7976C103.478
              55.8465 103.738 55.8884 103.983 55.8953C104.215 55.9163 104.439 55.9232 104.629 55.9232C104.818
              55.9232 105.015 55.9163 105.26 55.8953C105.492 55.8884 105.758 55.8535 106.053 55.7976V51.1641C106.053
              50.6896 106.004 50.2709 105.899 49.8941C105.955 49.8732 106.06 49.8452 106.207 49.8173C106.362
              49.7894 106.523 49.7755 106.677 49.7755C107.141 49.7755 107.477 49.9011 107.681 50.1383C107.884
              50.3756 107.99 50.7873 107.99 51.3386V55.7976C108.284 55.8465 108.544 55.8884 108.789 55.8953C109.021
              55.9163 109.245 55.9232 109.435 55.9232C109.624 55.9232 109.821 55.9163 110.059 55.8953C110.291
              55.8884 110.565 55.8535 110.859 55.7976V51.0525C110.859 50.2639 110.733 49.6359 110.487 49.1614C110.256
              48.6869 109.94 48.324 109.554 48.0658C109.182 47.8076 108.754 47.6471 108.284 47.5773C107.821 47.4866
              107.365 47.4447 106.93 47.4447C106.432 47.4447 105.99 47.4936 105.597 47.6052C105.204 47.7169 104.853
              47.8285 104.566 47.9681C104.187 47.7588 103.766 47.6192 103.31 47.5494C102.854 47.4796 102.397 47.4378
              101.941 47.4378C101.071 47.4308 100.363 47.4936 99.8154 47.6262M89.0733 55.7907C89.368 55.8395 89.6206
              55.8814 89.8521 55.8884C90.0766 55.9093 90.2871 55.9163 90.4836 55.9163C90.666 55.9163 90.8695 55.9093
              91.108 55.8884C91.3396 55.8814 91.6132 55.8465 91.9079 55.7907V49.5591C92.0202 49.5382 92.1886 49.5312
              92.3991 49.5312C92.7779 49.5312 93.0586 49.6219 93.227 49.8034C93.4094 49.9708 93.5006 50.1941 93.5006
              50.4663C93.5006 50.7384 93.4305 50.9966 93.2831 51.2479C93.1358 51.4781 92.8621 51.7014 92.4692
              51.9108L92.2377 52.0364L94.1111 55.7837C94.3005 55.8256 94.5461 55.8535 94.8338 55.8814C95.1214 55.9093
              95.4372 55.9093 95.7529 55.9093C96.0195 55.9093 96.2791 55.9023 96.5528 55.8814C96.8404 55.8604 97.086
              55.8325 97.3176 55.7837L95.388 52.3295C95.4652 52.2667 95.5705 52.1829 95.6898 52.0713C95.8161 51.9596
              95.9283 51.834 96.0476 51.6526C96.1669 51.4712 96.2581 51.2618 96.3353 51.0176C96.4124 50.7803 96.4545
              50.4872 96.4545 50.1593C96.4545 49.294 96.1107 48.6241 95.4231 48.1495C94.7496 47.6611 93.7252 47.4238
              92.357 47.4238C91.8518 47.4238 91.3115 47.4447 90.7292 47.4866C90.1678 47.5285 89.6135 47.5843 89.0873
              47.6471V55.7976L89.0733 55.7907ZM84.7091 51.7433C84.7091 51.0664 84.5828 50.55 84.3372 50.1872C84.1057
              49.8313 83.7338 49.6499 83.2356 49.6499C82.7375 49.6499 82.3726 49.8313 82.1341 50.1872C81.8955 50.5431
              81.7762 51.0594 81.7762 51.7433C81.7762 52.4272 81.8955 52.9226 82.1341 53.2785C82.3656 53.6344 82.7375
              53.8158 83.2356 53.8158C83.7338 53.8158 84.0986 53.6344 84.3372 53.2785C84.5898 52.9226 84.7091 52.4132
              84.7091 51.7433ZM78.8784 51.7433C78.8784 51.1013 78.9697 50.5082 79.1521 49.9778C79.3415 49.4405 79.6222
              48.9799 79.98 48.6031C80.3519 48.2263 80.808 47.9332 81.3482 47.7308C81.8885 47.5215 82.5129 47.4168
              83.2216 47.4168C83.9303 47.4168 84.5758 47.5215 85.123 47.7308C85.6633 47.9332 86.1194 48.2263 86.4772
              48.6031C86.8491 48.9799 87.1297 49.4405 87.3052 49.9778C87.4946 50.5012 87.5928 51.0943 87.5928
              51.7433C87.5928 52.3923 87.4946 52.9575 87.3052 53.4879C87.1227 54.0042 86.8491 54.4578 86.4772
              54.8346C86.1194 55.2045 85.6633 55.4906 85.123 55.693C84.5828 55.8884 83.9513 55.993 83.2216
              55.993C82.4919 55.993 81.8885 55.8884 81.3482 55.693C80.808 55.4906 80.3519 55.2045 79.98
              54.8346C79.6222 54.4578 79.3415 54.0042 79.1521 53.4879C78.9697 52.9645 78.8784 52.3783
              78.8784 51.7433ZM72.5356 53.7321C72.5777 53.7321 72.6409 53.7391 72.704 53.746C72.7812 53.753
              72.8934 53.76 73.0408 53.76C73.6723 53.76 74.1424 53.5995 74.4511 53.2715C74.7668 52.9366
              74.9282 52.3853 74.9282 51.6247C74.9282 50.9478 74.7738 50.4593 74.4721 50.1523C74.1634 49.8383
              73.7284 49.6778 73.1671 49.6778C73.0338 49.6778 72.9075 49.6847 72.7952 49.6917C72.683 49.6987
              72.5988 49.7127 72.5356 49.7196V53.7321ZM72.6759 47.4168C73.5951 47.4168 74.3669 47.5215 75.0124
              47.7169C75.6649 47.9193 76.1982 48.2054 76.6192 48.5752C77.0401 48.9311 77.3419 49.3777 77.5383
              49.8941C77.7348 50.4105 77.826 50.9897 77.826 51.6247C77.826 52.2597 77.7207 52.8947 77.5173
              53.432C77.3278 53.9694 77.0191 54.4299 76.5841 54.8067C76.1631 55.1836 75.6158 55.4836 74.9422
              55.693C74.2757 55.8884 73.4688 55.993 72.5216 55.993C71.9743 55.993 71.4761 55.9721 71.0341
              55.9302C70.6061 55.9023 70.157 55.8535 69.6799 55.7837V47.6401C70.157 47.5913 70.6552 47.5355 71.1885
              47.5006C71.7147 47.4447 72.2129 47.4238 72.6759 47.4099"
                      fill="black"/>
                <path d="M128.646 45.5048C128.646 45.5048 128.702 45.5048 128.737 45.4909C128.772 45.4769 128.8 45.4909
              128.828 45.4909C128.856 45.4909 128.884 45.4909 128.912 45.4909C128.947 45.4909 128.976 45.4909 129.004
              45.5048L129.298 46.2096L129.6 45.5048C129.6 45.5048 129.649 45.5048 129.677 45.4909C129.705 45.4769
              129.733 45.4909 129.761 45.4909C129.789 45.4909 129.818 45.4909 129.853 45.4909C129.888 45.4909 129.909
              45.4909 129.937 45.5048L130 46.8586C130 46.8586 129.958 46.8586 129.93 46.8726C129.902 46.8726 129.867
              46.8726 129.825 46.8726C129.782 46.8726 129.719 46.8726 129.656 46.8516L129.621 46.0631L129.404
              46.5795C129.404 46.5795 129.354 46.5795 129.333 46.5795C129.305 46.5795 129.291 46.5795 129.27
              46.5795C129.249 46.5795 129.228 46.5795 129.207 46.5795C129.186 46.5795 129.165 46.5795 129.144
              46.5655L128.947 46.0561L128.919 46.8377C128.863 46.8516 128.807 46.8586 128.758 46.8586C128.716
              46.8586 128.653 46.8586 128.597 46.8377L128.653 45.4909L128.646 45.5048ZM127.741 45.7979H127.404C127.39
              45.7491 127.383 45.6932 127.383 45.6514C127.383 45.6095 127.383 45.5607 127.404 45.5048H128.442C128.442
              45.5048 128.456 45.5537 128.456 45.5816C128.456 45.6095 128.456 45.6235 128.456 45.6514C128.456 45.6932
              128.456 45.7421 128.435 45.7979H128.098V46.8656C128.028 46.8795 127.972 46.8865 127.916 46.8865C127.86
              46.8865 127.804 46.8865 127.734 46.8656V45.7979H127.741Z"
                      fill="black"/>
              </svg>
            </div>
            <div class="modalidade" v-if="productName.majorCategory === 'Mobilidade Rural'">
              <div class="product">
                <div class="content-text">
                  <p class="more">Quero saber mais!</p>
                  <p>Estou interessado no produto, gostaria de saber mais sobre:</p>
                </div>
                <div class="content-product">
                  <h3>{{ productVariant.name }} <br>
                    <span>
                 {{ productName.label_list }}
                  </span>
                  </h3>
                  <div class="content-image-product">
                    <img :src="productName.featured_image.fullUrl" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="modalidade" v-else-if="productName.majorCategory === 'Mobilidade Urbana'">
              <div class="product">
                <div class="content-text">
                  <p class="more"
                     :class="{
                       'navy-color': model.reference === 'Navy',
                       'mint-color' : model.reference === 'Mint',
                       'pink-color' : model.reference === 'Pink',
                       'snow-color' : model.reference === 'Snow',}">Quero saber mais!</p>
                  <p>Estou interessado no produto, gostaria de saber mais sobre:</p>
                </div>
                <div class="content-product">
                  <h3>{{ productVariant.name }}
                    <span
                      :class="{
                       'navy-color': model.reference === 'Navy',
                       'mint-color' : model.reference === 'Mint',
                       'pink-color' : model.reference === 'Pink',
                       'snow-color' : model.reference === 'Snow',}">
                 {{ productVariant.reference }}
                  </span>
                  </h3>
                  <div class="content-image-product">
                    <img :src="productVariant.featured_image.fullUrl" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-formulario">
            <Transition name="fade-slide" mode="out-in">
              <div v-if="isSubmitted" class="success-container" key="success">
                <div class="success-icon" :class="props.model.reference.toLowerCase() + '-color'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <h2>{{ trans("Enviado!") }}</h2>
                <p>Obrigado pelo seu interesse. Entraremos em contacto em breve.</p>
                <button type="button" @click="close" class="button-orange send"
                        :class="props.model.reference.toLowerCase() + '-color'">
                  {{ trans("Fechar") }}
                </button>
              </div>
              <form v-else @submit.prevent="submitForm" key="form">
                <div class="div-input">
                  <div class="input">
                    <label for="InputName">{{ trans("Name") }} <span
                      v-balloontip="{
                      content: trans('Obrigatório'),
                      position: 'bottom',
                      trigger: 'hover',
                      hideOnTargetClick: true,
                      hideOnMouseOut: true,
                      hideOnScroll: true,
                      hideOnResize: true,
                      sticky: true,
                      interactive: true,
                      theme: 'light-border',
                      }"
                      :class="props.model.reference.toLowerCase() + '-color'">*</span></label>
                    <input type="text" v-model="formData.name" required class="form-control" id="InputName"
                           :placeholder="trans('First Name Last Name')">
                  </div>
                  <div class="input">
                    <label for="InputEmail">{{ trans("E-mail") }} <span
                      v-balloontip="{
                      content: trans('Obrigatório'),
                      position: 'bottom',
                      trigger: 'hover',
                      hideOnTargetClick: true,
                      hideOnMouseOut: true,
                      hideOnScroll: true,
                      hideOnResize: true,
                      sticky: true,
                      interactive: true,
                      theme: 'light-border',
                      }"
                      :class="props.model.reference.toLowerCase() + '-color'">*</span></label>
                    <input type="email" v-model="formData.email" required class="form-control" id="InputEmail"
                           placeholder="email@mail.com">
                  </div>
                </div>
                <div class="div-input">
                  <div class="input">
                    <label for="InputContact">{{ trans("Contact") }} <span
                      v-balloontip="{
                      content: trans('Obrigatório'),
                      position: 'bottom',
                      trigger: 'hover',
                      hideOnTargetClick: true,
                      hideOnMouseOut: true,
                      hideOnScroll: true,
                      hideOnResize: true,
                      sticky: true,
                      interactive: true,
                      theme: 'light-border',
                      }"
                      :class="props.model.reference.toLowerCase() + '-color'">*</span></label>
                    <input type="tel" v-model="formData.number_phone" required class="form-control" id="InputContact"
                           placeholder="+351 000 000 000">
                  </div>
                  <div class="input">
                    <label for="InputAddress">{{ trans("Address") }}</label>
                    <input type="text" v-model="formData.address" class="form-control" id="InputAddress"
                           :placeholder="trans('Street name')">
                  </div>
                </div>
                <div class="div-input postal">
                  <div class="input code">
                    <label for="postal_code">{{ trans("Postal Code") }}</label>
                    <input type="text" v-model="formData.postal_code" id="postal_code" class="form-control"
                           placeholder="0000-000">
                  </div>
                </div>
                <p v-if="message.text" class="error-msg">{{ message.text }}</p>
                <div class="content-button">
                  <button type="submit"
                          class="button-orange send"
                          :disabled="isSubmitting"
                          :class="props.model.reference.toLowerCase() + '-color'">
                    {{ isSubmitting ? 'A enviar...' : 'Enviar' }}
                  </button>
                  <button type="button" @click="resetForm" class="button-orange clear"
                          :class="props.model.reference.toLowerCase() + '-color'">
                    Limpar dados
                  </button>
                </div>
              </form>
            </Transition>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>


.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}




.error-msg {
  color: #e74c3c;
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
}


.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
